#! /usr/bin/env node
'use strict';
import { init } from '../index';
init();
